import ContactFloatingButton from './ContactFloatingButton'

export default function SkillsMobile() {
  return (
    <div className=''>
      {/* 모바일 앱 - iOS, Android 등 다양한 플랫폼에서 ~ */}
      <div className='container mx-auto bg-sk-white max-md:px-20'>
        <div className='flex items-start justify-between py-48 sm:py-64 sm:items-center max-sm:flex-col sm:flex max-sm:gap-12'>
          <div className='flex flex-col items-start gap-6'>
            <p className='text-h2-medium sm:text-h1-medium text-sk-info'>모바일 앱</p>
            <p className='text-title3-bold lg:text-title2-bold 2xl:text-title1-bold text-sk-default'>
              iOS, Android 등 다양한 플랫폼에서 <br className='hidden 2xs:block' />
              사용자 경험을 최적화한 앱 서비스
            </p>
          </div>
          <p className='text-body1-long-medium text-sk-sub'>
            모바일 앱 솔루션은 기업이 고객과의 상호작용을 강화하고,{' '}
            <br className='hidden 2xs:block' />
            운영을 디지털화하여 효율성을 극대화할 수 있도록 돕는 맞춤형 소프트웨어입니다
          </p>
        </div>
      </div>
      {/* 사례 */}
      <div className='container flex items-start justify-center gap-40 mx-auto max-sm:flex-col py-60 sm:py-80 bg-sk-white max-md:px-20'>
        <div className='flex flex-col items-start gap-32'>
          <img src={require('assets/images/skills-mobile_ex1.png')} alt='' />
          <div className='flex flex-col items-start gap-16'>
            <div className='flex flex-col items-start gap-4'>
              <p className='text-body1-medium sm:text-h2-medium text-sk-info'>고객 사례</p>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
                키오스크 연동 어플리케이션
              </p>
            </div>
            <p className='text-body1-medium sm:text-h2-medium text-sk-default'>
              디바이스에 구애 받지 않고 하나의 데이터를 자연스럽게{' '}
              <br className='hidden 2xs:block' />
              연결한 모바일 앱 구현이 가능합니다
            </p>
          </div>
        </div>
        <div className='flex flex-col items-start gap-32'>
          <img src={require('assets/images/skills-mobile_ex2.png')} alt='' />
          <div className='flex flex-col items-start gap-16'>
            <div className='flex flex-col items-start gap-4'>
              <p className='text-body1-medium sm:text-h2-medium text-sk-info'>고객 사례</p>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
                AI 이미지 생성형 앱
              </p>
            </div>
            <p className='text-body1-medium sm:text-h2-medium text-sk-default'>
              사용자가 쉽게 자신만의 독창적인 이미지를 만들 수 있도록 도와주며,{' '}
              <br className='hidden sm:block' />
              텍스트 설명이나 간단한 입력을 통해 자동으로 이미지를 생성할 수 있는 솔루션입니다
            </p>
          </div>
        </div>
      </div>
      {/* 지나치지 않고 편리함과 ~ */}
      <div className='py-60 sm:pt-80 skills_background2'>
        <div className='container flex items-center justify-center mx-auto max-md:px-20'>
          <div className='flex items-center gap-60 sm:gap-120 max-sm:flex-col'>
            <img src={require('assets/images/skills-design_image1.png')} alt='' />
            <div className='flex flex-col items-start gap-24'>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold test-sk-default'>
                지나치지 않고 편리함과
                <br />
                다양성을 생각합니다
              </p>
              <p className='text-body1-long-regular text-sk-info'>
                홈페이지 제작 시에는 많은 고려사항이 있습니다
                <br />주 타켓층, 브랜드 컨셉, 사이트 특성 등 셀 수 없이 많은데{' '}
                <br className='hidden 2xs:block' />
                사용 기기마저 점점 많아져서 세심하게 제작할수록 오래 사용하실 수 있어요
                <br />
                전문가가 꼼꼼히 체크하고 제작하겠습니다
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* 원하는 대로 ~ */}
      <div className='flex skills_background2 sm:h-[800px] justify-center mb-[-220px] sm:mb-[-260px] py-60'>
        <div className='container flex items-center justify-center mx-auto gap-60 sm:gap-120 max-sm:flex-col-reverse'>
          <div className='flex flex-col items-start gap-24 px-20 md:px-0'>
            <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
              원하는 대로 필요한 대로
              <br />
              맞춤형 디자인을 제공합니다
            </p>
            <p className='text-body1-long-regular text-sk-info'>
              한정적인 템플릿과 다르게 원하는 대로 필요한 대로 디자인을 제공하고{' '}
              <br className='hidden sm:block' />
              기능을 제작합니다 특별한 사업을 위해 특별한 서비스를 이용해 보세요
            </p>
          </div>
          <div className='flex items-center pl-20 max-md:overflow-x-hidden gap-36 md:gap-80 md:px-0'>
            <img src={require('assets/images/skills-design_image4.png')} alt='' />
            <img src={require('assets/images/skills-mobile_image1.png')} alt='' />
            <img src={require('assets/images/skills-mobile_image2.png')} alt='' />
          </div>
        </div>
      </div>
      <ContactFloatingButton />
    </div>
  )
}
